module.exports = __webpack_public_path__ + "d4daeef0cc4e8b47d966d68d1640af70.svg";